module.exports = __webpack_public_path__ + "media/images/logo-de666a054704b67b62979cf8e6d0f96d.png";